export function filterLanguage(arr, language) {
  console.log("filterLanguage",arr, language);
  console.log(arr?.filter((l) => l?.locale === language));

  const filtered = arr?.filter((l) => l?.locale === language);
  return filtered ? filtered : [];
}
